import Vue from 'vue';

import permission from './permission';

Vue.directive('permission', permission);



// WEBPACK FOOTER //
// ./src/directive/index.js